import { render, staticRenderFns } from "./ClienteXUnidade.vue?vue&type=template&id=0f8ae6d8"
import script from "./ClienteXUnidade.vue?vue&type=script&lang=js"
export * from "./ClienteXUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports